<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
      <vs-button  @click = "myFilter"
       flat icon class="filter-btn-mobile">
       <span> Filters</span> <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
      </vs-button>      
        <div class="knowledge_base_wrap v2">
          <div class="knowledge_base_filters" :class="{filtersopen: isActive}">
            <div class="filer-bg"></div>
            <div class="knowledge_base_filters_cnt">
              <div class="search">
                <input v-model="filters.title" 
                 placeholder="Search By Title"
                 @keyup="get_list()"
                type="text" >
              </div>
              <div class="filter-scrool">
                <!-- <h4>Filter By 2525</h4> -->
                <!--<div class="knowledge_filters_cnt">
                  <h6>Type</h6>
                  
                  <ul class="centerx">
                    <li v-for="(type ,i) in types"  v-bind:key="i">
                    
                      <vs-checkbox :name="'types_'+i" v-model="type.wrk_Around" @change="check($event ,type._id ,'typeIds')"    >{{type.name}}</vs-checkbox>
                    </li>
                    
                  </ul>
                </div>
                <div class="knowledge_filters_cnt"
                >
                  <h6>KDB Area </h6>
                  <ul class="centerx">
                    <li v-for="(type ,i) in Areas"  v-bind:key="i">
                  
                      <vs-checkbox :name="'area_'+i" v-model="type.wrk_Around" @change="check($event ,type._id ,'areaIds')"    >{{type.name}}</vs-checkbox>
                    </li>
                    
                  </ul>
                </div>-->
                <div class="knowledge_filters_cnt"
                >
                  <!-- <h6>Device Family </h6> -->
                  <ul class="centerx">
                    <li v-for="(type ,i) in deviceFamily"  v-bind:key="i">
                      <label>{{type.name}}</label>
                      <vs-checkbox :name="'device_family_'+i" v-model="type.wrk_Around" @change="check($event ,type._id ,'deviceFamIds')"    >{{type.name}}</vs-checkbox>
                    </li>
                    
                  </ul>
                </div>
                <!-- <div class="knowledge_filters_cnt"
                >
                  <h6>Version </h6>
                  <ul class="centerx">
                    <li v-for="(type ,i) in versions"  v-bind:key="i">
                  
                      <vs-checkbox :name="'version_'+i" v-model="type.wrk_Around" @change="check($event ,type._id ,'versionIds')"    >{{type.name}}</vs-checkbox>
                    </li>
                    
                  </ul>
                </div> -->
              </div>
              <!-- <div class="knowledge_filters_cnt"
              >
                <h6>Fixed Version </h6>
                <ul class="centerx">
                  <li v-for="(type ,i) in fixversions"  v-bind:key="i">
                 
                    <vs-checkbox :name="'fixVersion_'+i" v-model="type.wrk_Around" @change="check($event ,type._id ,'fixVersion')"    >{{type.name}}</vs-checkbox>
                  </li>
                   
                </ul>
              </div> -->
            </div>
          </div>
          <div class="knowledge_base_cnt knowledge-base-left">
            <ul class="breadCrums">
              <li v-if="selectedCrum != ''" @click="selectedCrum = '';selectedSubFolder = '';knowledgeDetails = null;get_list();updateMainRoute(true)">
                Documents
              </li>
              <li v-if="selectedCrum != ''" @click="selectedSubFolder = '';knowledgeDetails = null; updateSubRoute(true)">
                {{ selectedCrum }}
              </li>
              <li v-if="selectedSubFolder != ''">
                {{selectedSubFolder}}
              </li>
              <!-- <li v-if="selectedCrum == 'Ara-2'"> selectedSubFolder
                Ara-2
              </li>
              <li v-if="selectedCrum == 'Drax-USB'">
                Drax-USB
              </li>
              <li v-if="selectedCrum == 'Drax-M.2'">
                Drax-M.2
              </li> -->
            </ul>

            <div class="folder_list" v-if="selectedCrum == ''">
              <!-- if you want dynamic device family enable below ul -->
              <ul v-if="list && list.length>0 && false">
                <template v-for="(type ,i) in deviceFamily">
                  <li v-if="getFolderVisibilty(type['_id'])" class="list_item" @click="selectedCrum = type['name'];get_list(type['_id'])">
                    <img src="@/assets/images/file-icons/folder.png">
                    <label v-if="type&&type['name']">{{type['name']}}</label>
                  </li>
                </template>
              </ul>
              <!-- Below is Static device family -->
              <ul v-if="list && list.length>0">
                <li v-if="getFolderVisibilty(1)" class="list_item" @click="selectedCrum = 'Ara-1';get_list(1); updateMainRoute();">
                  <img @click="addBreadCrums('Ara-1')" src="@/assets/images/file-icons/folder.png">
                  <label>Ara-1</label>
                </li>
                <li v-if="getFolderVisibilty(8)" class="list_item" @click="selectedCrum = 'Ara-2';get_list(8); updateMainRoute();">
                  <img @click="addBreadCrums('Ara-2')" src="@/assets/images/file-icons/folder.png">
                  <label>Ara-2</label>
                </li>
                <li v-if="getFolderVisibilty(5)" class="list_item" @click="selectedCrum = 'Drax-USB';get_list(5); updateMainRoute();">
                  <img @click="addBreadCrums('Drax-USB')" src="@/assets/images/file-icons/folder.png">
                  <label>Drax-USB</label>
                </li>
                <li v-if="getFolderVisibilty(6)" class="list_item" @click="selectedCrum = 'Drax-M.2';get_list(6); updateMainRoute();">
                  <img @click="addBreadCrums('Drax-M.2')" src="@/assets/images/file-icons/folder.png">
                  <label>Drax-M.2</label>
                </li>
                
              </ul>
            </div>
            <template v-if="selectedCrum !='' && !selectedSubFolder"> 
              <template v-if="false"  v-for="(knowledge ,index) in list" >
                <div class="knowledge_base_list user_knowledge_list"  v-bind:key="index" >
                  <div>
                    <router-link :to="'/documentation-details/'+knowledge['_id']" class="knowledge_title "  >{{knowledge.title}}</router-link>
                    <p> {{knowledge.description}}</p>
                  </div>
                  <div>
                    <router-link :to="'/documentation-details/'+knowledge['_id']" class="primary_btn approve_btn"  >View</router-link>
                  </div>
                </div>
              </template>
              <template  v-for="(knowledge ,index) in list" >
                <div class="knowledge_base_list user_knowledge_list"  v-bind:key="index" >
                  <div>
                    <span  class="knowledge_title" @click="getDocDetails(knowledge)" >{{knowledge.title}}</span>
                    <p> {{knowledge.description}}</p>
                  </div>
                  <div>
                    <span  class="primary_btn approve_btn" @click="getDocDetails(knowledge); updateSubRoute();" >View</span>
                  </div>
                </div>
              </template>
              <template v-if="list.length<=0">
                <div class="center-align no_data mart30">No Data Found!</div>
              </template>
            </template>
            <!-- <div class="pagination_wrap" v-if="totalpages > 0">
                <div class="pagination_content">
                <h6>Show Records</h6>
                

                <multiselect
            :multiple="false" 
              @input="change_perPage()"
            placeholder="Page"
            
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            v-model="perPage" :options="perPeges" >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} selected</span
                >
                <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                ></span>
              </template>
              
            </multiselect>
            </div>
                <vs-pagination
                :total="totalpages"
                :max="7"
                v-model="page"

                />
            </div> -->

            <div id="knowledge-base-page" class="doc_details_page" v-if="selectedSubFolder != '' && knowledgeDetails">
              <div class="page_header_wrap">
                <div class="page_header">
                  <div>
                    <h2 >Documentation Details</h2>
                  </div>
                </div>
              </div>        
              <div class="knowledge_base_wrap">
                <div class="knowledge_base_cnt knowledge_base_details">
                  <div class="knowledge_base_list">
                    <ul>
                      <li v-if="checkValue(knowledgeDetails  , 'title' )">
                        <label>Title</label> <p> 
                          {{checkValue(knowledgeDetails  , 'title' )}}
                          </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'description' )">
                          <label>Description</label> <p>
                            {{checkValue(knowledgeDetails  , 'description' )}}
                          </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'bug' )">
                        <label>Bug</label> <p>
                          {{checkValue(knowledgeDetails  , 'bug' )}}
                          </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'deviceFamDetails' ,'name')">
                        <label>Device Family</label> <p> 
                          {{checkValue(knowledgeDetails  , 'deviceFamDetails' ,'name')}}
                          </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'typeDetails' ,'name')!=''">
                        <label>Type Details</label> <p>
                          {{checkValue(knowledgeDetails  , 'typeDetails' ,'name')}}
                          
                            </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'versionDetails' ,'name' ) !=''">
                      <label>Version Details</label> <p>
                        {{checkValue(knowledgeDetails  , 'versionDetails' ,'name' )}}
                        
                        </p>
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'fixVersionDetails' ,'name' ) !=''">
                        <label>Fixed Version Details</label> <p>
                        {{checkValue(knowledgeDetails  , 'fixVersionDetails' ,'name' )}} </p>
                      </li>
                      <li>
                      <label>Documents</label> 
                      <p v-if="knowledgeDetails.documents && knowledgeDetails.documents.length > 0">
                        {{knowledgeDetails.documents[0].name}}
                        <span @click="download_file(knowledgeDetails.documents[0])" class="material-icons download">get_app</span>
                        </p>
                          
                      </li>
                      <li v-if="checkValue(knowledgeDetails  , 'wrkAround' ) !=''">
                      <label>Work Around</label> <p>
                        {{checkValue(knowledgeDetails  , 'wrkAround' )}}
                        </p>
                      </li>
                    </ul> 
                  </div>
                  
                </div>
              </div>    
            </div>
          </div>
        </div>    
          
    </div>
</template>


<script>
import vSelect from 'vue-select'
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Multiselect from "vue-multiselect-inv";
import moment from "moment";
import _ from "lodash";
export default {
  components: {
    vSelect,
    DateRangePicker,
    Multiselect
  },
  watch: {
    '$store.state.isMainRoute': function(val) {
      if (val === false) {
        this.get_list()
        this.selectedCrum = ''
        this.selectedSubFolder = ''
        this.knowledgeDetails= null
      }
    },
    '$store.state.isSubRoute': function(val) {
      if (val === false) {
        this.selectedSubFolder = ''
        this.knowledgeDetails = null
      }
    }
  },



  computed: {
    validateMe () {
     // console.log(JSON.stringify(this.newKnowledge));
      //this.errors.any()
      if( this.errors.any()
      || (  this.newKnowledge.deviceFamId ==null || this.newKnowledge.deviceFamId ==''  )
      || (  this.newKnowledge.typeId ==null || this.newKnowledge.typeId ==''  )
      || (  this.newKnowledge.bug ==null || this.newKnowledge.bug =='' || this.newKnowledge.bug.trim() ==''   )
      || (  this.newKnowledge.areaId ==null || this.newKnowledge.areaId ==''  )
      || (  this.newKnowledge.version ==null || this.newKnowledge.version ==''  )
      || (  this.newKnowledge.title ==null || this.newKnowledge.title =='' || this.newKnowledge.title.trim() ==''   )
      || (  this.newKnowledge.description ==null || this.newKnowledge.description =='' || this.newKnowledge.description.trim() ==''   )
      || (  this.newKnowledge.fixVersion ==null || this.newKnowledge.fixVersion ==''  )
     
      ){
        let l = "deviceFamId "+this.newKnowledge.deviceFamId +" \n --- "
                +"typeId "+this.newKnowledge.typeId +" \n -- "
               + "bug "+this.newKnowledge.bug +" \n ---"
                +"areaId "+this.newKnowledge.areaId +" \n -- "
                +"version "+this.newKnowledge.version +" \n-- "
                +"title "+this.newKnowledge.title +" \n --"
                +"description "+this.newKnowledge.description +" \n -- "
                +"FixVer "+this.newKnowledge.fixVersion +" \n --";
          //console.log(l);
        return true;
      }else{
        return false;
      }
    },
    getFolderVisibilty(){
      return (data)=>{
        let returnVal = false;
        if(this.list && this.list.length>0){
          let findObj = _.find(this.list, {deviceFamId:data});
          if(findObj){
            returnVal = true;
          }
        }
        return returnVal;
      }
    },
  },
  data () {    
    return {
      knowledgeBaseId:'',
      selectedSubFolder:'',
      knowledgeDetails:null,
      selectedCrum:'',
      breadCrumsList:[],
      disabledBtn:false,
      isSidebarOpen: false,
      isActive: false,
      deviceFamily:[],
      types:[],
      Areas:[],
      versions:[],
      fixversions:[],
      selectoptions: ['list', 'of', 'options'],
      newKnowledge:{
        "deviceFamId":'',
        "deviceFamDetails":null,
        "typeId": '',
        typeDetails:null,
        "bug": '',
        "areaId": '',
        areaDetails:null,
        "version": "",
        versionDetails:null,
        "title": "",
		    "description": "",
        "wrkAround": "",
        "wrk_Around":false,
        
        "fixVersion": "",
        fixVersionDetails:null,
	},
      description:'',
      statusOptions:[],
      statusFilter:null,
      Title:'',
      popupeditKnowledgeBase:false,
      popupcreateticket:false,
      textarea:'',

      selected:'',
      sortKeys: {
        name: 1,
        statusName: 1,
        createdOn: -1,
        email: 1,
        roleName: 1
      },
      list: [],
      sortKey: {},
      email: '',
      users: '',
      page: 1,
      perPage: 25,
      totalpages: 0,
      perPeges: [25, 50, 75, 100],
      filters:{
			"title": "",
			"deviceFamIds": [],
			"typeIds": [],
			"areaIds": [],
      "versionIds": []
    },
    selected_createdDateRange:{},
    autoApply: "",
    }
  },
  methods: {
    updateMainRoute(action){
      if(action){
        this.$store.commit('UPDATE_MAIN_ROUTE', false); 
        this.$store.commit('UPDATE_SUB_ROUTE', false); 
      }else{
        this.$store.commit('UPDATE_MAIN_ROUTE', true);
      }
      
    },
    updateSubRoute(action){
      if(action){
        this.$store.commit('UPDATE_SUB_ROUTE', false);
      }else{
        this.$store.commit('UPDATE_SUB_ROUTE', true);
      }
      
    },
    download_file(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }
      let postdata = { keyName: value.url };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        window.open(response.data.result.data, "_blank");
      });
    },
    checkValue(object =null ,mainKey='' ,subKey =''){
         if(object != null && mainKey !='' ){
             if(_.has(object ,mainKey)){
 
                 if(subKey !=''){
                     if( _.has(object[mainKey] ,subKey )){
                         return object[mainKey][subKey];
 
                     }else{
                         return '';
 
                     }
 
                 }else{
                     return object[mainKey];
 
                 }
 
             }else{
                 return '';
             }
 
         }else{
             return '';
         }
 
    

    },
    getKnowledgeDetails() { 
      const payload = {
        knowledgeBaseId: this.knowledgeBaseId,
      };
    
      this.$store
        .dispatch("knowledgeBaseDetails", payload)
        .then((res) => {
          this.knowledgeDetails = res;
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    changedBreadcrumb(breadcrumb) {
      if (this.checkProperty(breadcrumb, "_id") == -1) {
        this.init();
      } else {

        let findIndex = _.findIndex(this.breadcrumbs, {
          _id: breadcrumb["_id"],
        });

        let tempBreadcrumbs = [];
        if (findIndex > -1) {
          _.forEach(this.breadcrumbs, (item, index) => {
            if (index <= findIndex) {
              tempBreadcrumbs.push(item);
            }
          });
        }
        this.breadcrumbs = tempBreadcrumbs;
        this.gotoSubFolder(breadcrumb, true);
       
      }
    },
    updateRoute(val){
      let text = "?selectedCrum="+val;
      console.log(text)
      this.$router.push({ query: text });
      console.log(this.$router)
    },
    addBreadCrums(name){
      let self = this
      // this.$router.push({ path: '/documentations', query: { baseFolder:name } }).catch(err => { })
      
    },
    getDocDetails(knowledge){
      console.log(JSON.stringify(knowledge))
      this.knowledgeBaseId = knowledge['_id'];
      this.selectedSubFolder = knowledge['title']
      this.getKnowledgeDetails();
    },
    myFilter: function() {
      this.isActive = !this.isActive;
      // some code to filter users
    },
   
    changedDevice(item){
      this.newKnowledge.deviceFamId  ='';
      if(item !=null){
        this.newKnowledge.deviceFamId =item._id;
      }
     
    },
    changedArea(item){
      this.newKnowledge.areaId ='';
      if(item !=null){
        this.newKnowledge.areaId =item._id;
      }
     
    },
    changedType(item){
      this.newKnowledge.typeId ='';
      if(item !=null){
        this.newKnowledge.typeId =item._id;
      }
    
    },
    changedVersion(item){
      this.newKnowledge.version ='';
      if(item !=null){
        this.newKnowledge.version =item._id;
      }
     
    },
    changedFxVersion(item){
      this.newKnowledge.fixVersion ='';
      if(item !=null){
        this.newKnowledge.fixVersion =item._id;
      }
      
    },
    check(e ,id ,type=''){
     if (e.target.checked) {
        this.filters[type].push(id);
     }else{
        if(this.filters[type].indexOf(id) > -1){
          this.filters[type].splice(this.filters[type].indexOf(id) ,1);
       }
     }
     this.page=1;
     this.get_list();
     
     
    },
    getTypes(){
      let payload = {
        page: 1,
        perpage: 1000000000,
        category: 'type'
      }
      this.$store.dispatch("getTypes" ,payload).then((response) => {
      this.types = response;
     
    });

    },
    getDeviceFamily(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'device_family'
      }
      this.$store.dispatch("getDeviceFamily" ,postData).then((response) => {
      this.deviceFamily = response;
     
    });

    },
    
    getAreas(){
      let postData ={
        page: 1,
        perpage: 10000000,
        category: 'area'
      }
      this.$store.dispatch("getAreas" ,postData).then((response) => {
     // this.Areas = response;
     this.Areas = _.filter(response, (obj)=> {
        return obj._id != 2;
      });
     
    });

    },
    getVersions(){
      let postData = {
      "filters":{ "title": ""},		
        "page": 1,
        "perpage": 1000000000,
        category: 'version'
      }
      this.$store
        .dispatch("getSdkVersionsList", postData)
        .then((response) => {
          this.versions = response.list;
          
         
        })
        .catch((err) => {
          console.log(err);
          
          
        });
    },
    
    getDetails(item,callFroEdit=false) {
     
      
      const payload = {
        knowledgeBaseId: item._id,
      };
    
      this.$store
        .dispatch("knowledgeBaseDetails", payload)
        .then((res) => {
         
          this.newKnowledge =res;
          this.newKnowledge.wrk_Around = false;
          if(this.newKnowledge.wrkAround =='yess'){
              this.newKnowledge.wrk_Around =true;
          }
          if(callFroEdit){
            this.edit();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    
      

    get_list (deviceFam = null) {
      let postData = {
        filters:{"title": this.filters.title,	"deviceFamIds": this.filters.deviceFamIds,	"typeIds":
         this.filters.typeIds, "versionIds":this.filters.versionIds,	"areaIds": this.filters.areaIds},
        sorting: this.sortKey, //{"path": "name","order": -1	},
        dcoumentationOnly: true,
        page: this.page,
        perpage: this.perPage
      };
      if(deviceFam){
        postData['filters']['deviceFamIds'] = [];
        postData['filters']['deviceFamIds'].push(deviceFam);
      }
      // if(this.filters.deviceFamIds.length>0){
      //   for( let i=0; i<this.filters.deviceFamIds.length;i++){
      //     postData.filters.deviceFamIds.push(this.filters.deviceFamIds[i]['_id'] )
      //   }
      // }
      // if(this.filters.typeIds.length>0){
      //   for( let i=0; i<this.filters.typeIds.length;i++){
      //     postData.filters.typeIds.push(this.filters.typeIds[i]['_id'] )
      //   }
      // }
      // if(this.filters.areaIds.length>0){
      //   for( let i=0; i<this.filters.areaIds.length;i++){
      //     postData.filters.areaIds.push(this.filters.areaIds[i]['_id'] )
      //   }
      // }
      // if(this.filters.versions.length>0){
      //   for( let i=0; i<this.filters.versions.length;i++){
      //     postData.filters.versions.push(this.filters.versions[i]['_id'] )
      //   }
      // }
      
      // if(_.has(this.selected_createdDateRange ,'startDate' ) && _.has(this.selected_createdDateRange ,'endDate' )){
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
      //   postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
      // }

      this.list = []
     this.$vs.loading()
      this.$store
        .dispatch('knowledgebaseList', postData)
        .then((response) => {
           this.$vs.loading.close();
           this.list = response.list
           this.totalpages = Math.ceil(response.totalCount / this.perPage)
        })
        .catch((err) => {
           this.$vs.loading.close();
          //console.log(err)
        })
    },
    change_perPage() {
        this.page = 1;

        this.get_list();
      },
    sortMe(sort_key = "") {
  
    this.sortKey = { path: "createdOn", order: 1 };
    if (sort_key != "") {
      this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
      this.sortKey = {};

      this.sortKey["path"] = sort_key;
      this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;

      this.get_list();
    }
  },  
  },
  
  mounted () {

  this.getDeviceFamily();
  this.getTypes();
  this.getAreas();
  this.getVersions();
  this.get_list()

  
    /*this.$store.dispatch('getRoles').then((response) => {
      this.userRoles = response
      console.log('userRoles', this.userRoles)
    })
    //getuser_status
    this.$store.dispatch('getuser_status').then((response) => {
      this.status_list = response
      console.log('status_list', this.status_list)
    })*/
  }
}
</script>


<style lang="scss">
// .knowledge-base-jumbotron-content {
//     background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
//     background-size: cover;
// }
</style>
